import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { supabase } from "@/integrations/supabase/client";
import type { NavigateFunction } from "react-router-dom";

export async function initPushNotifications(navigate?: NavigateFunction) {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === "prompt") {
    const result = await PushNotifications.requestPermissions();
    if (result.receive !== "granted") {
      return;
    }
  } else if (permStatus.receive !== "granted") {
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener("registration", async (token) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await supabase.from("profiles").update({
          push_token: token.value,
          device_platform: Capacitor.getPlatform(),
        }).eq("id", user.id);
      }
    } catch {
      // silently fail
    }
  });

  PushNotifications.addListener("registrationError", () => {
    // silently fail
  });

  PushNotifications.addListener("pushNotificationReceived", () => {
    // notification received in foreground — no-op
  });

  PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    const data = action.notification.data;
    if (data?.route && navigate) {
      navigate(data.route);
    }
  });
}
